'use strict';

var util = require('./property-util');

module.exports = {
    isAdmin: function (user) {
        if (user != undefined) {
            return user.admin;
        } else {
            return false;
        }
    },

    isLoggedIn: function (user) {
        return util.isDefined(user);
    }
};

